import { useEffect, useState } from 'react';
import './tokens-details.css';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { base64ToBlob, getUserNameFromStoreData, handleError } from '../../../utils';
import http from '../../../core/service/http';


export const useVerifyUserHook = () => {
  const [users, setUsers] = useState([]);
  const [loadRecord, setLoadRecord] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [recordCount, setRecordCount] = useState(25);
  const auth = useSelector((state) => state?.appStore?.auth);
  const getUsers = async () => {
    try {
      setLoading(true);
      const response = await http.get("/v1/users/");
      if (response.data) {
        setUsers(() => response.data);
        setLoading(false);
      }
    } catch (error) {
      if (error.response) {
        handleError(error.response.data.message || "Login failed");
      } else {
        handleError("Network error. Please try again later.");
      }
      setLoading(false);
    }
  };

  const filterHandler = (data) => {
    if (searchTerm == "") {
      return true;
    }
    return (
      data.member_id
        .toString()
        .toLowerCase()
        .indexOf(searchTerm.toLowerCase()) > -1 ||
      `${data.first_name} ${data.last_name}`
        .toLowerCase()
        .indexOf(searchTerm.toLowerCase()) > -1 ||
      data.email?.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
      `${data.status == 0 ? "Not Verified" : "Verified"}`
        .toString()
        .indexOf(searchTerm.toLowerCase()) > -1
    );
  };

  const updateStatus = async (userData) => {
    try {
      setLoadRecord((prevData) => ({ ...prevData, [userData.id]: true }));
      await http.patch("/v1/users/" + userData.id, {
        status: userData.status == 0 ? 1 : 0, //TOGGLE STATUS
      });
      setLoadRecord((prevData) => {
        delete prevData[userData.id];
        return prevData;
      });
      getUsers();
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getUsers();
  }, []);

  return {
    users,
    loadRecord,
    isLoading,
    setSearchTerm,
    recordCount,
    setRecordCount,
    auth,
    getUsers,
    filterHandler,
    updateStatus
  };
};
